// @flow
import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { toggleTips } from '../actions/tips';

const useTips = () => {
	const tips = useSelector((state) => state.tips);
	const dispatch = useDispatch();

	const toggleTipsCb = useCallback(
		(state: boolean) => {
			dispatch(toggleTips(state));
		},
		[dispatch]
	);

	return [tips, toggleTipsCb];
};

export default useTips;
